import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface AuthServiceFeConfig {
  endpoint?: string;
}

export const AUTH_SERVICE_FE_CONFIG = new InjectionToken<AuthServiceFeConfig>(
  'AUTH_SERVICE_FE_CONFIG',
);

export function provideAuthServiceFe(
  config: AuthServiceFeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: AUTH_SERVICE_FE_CONFIG,
      useValue: config,
    },
  ]);
}
